import { Text, View } from "@react-pdf/renderer";
import { dietNotes, terms_conditions_styles } from "./billingPdf/style";
import { loadScript } from "utils/common";
import { toast } from "react-toastify";
import Logomain from "assets/images/creware.png";
import { createRazorpayOrder } from "firebaseConfig";
import Html from "react-pdf-html";

export const keyChanger = (key) => {
  switch (key) {
    case "earlyMorning":
      return "Early Morning";

    case "breakfast":
      return "Breakfast";

    case "midMorning":
      return "Mid Morning";

    case "brunch":
      return "Brunch";

    case "midMeal":
      return "Mid Meal";

    case "lunch":
      return "Lunch";

    case "postLunch":
      return "Post Lunch";

    case "evening":
      return "Evening";

    case "beforeDinner":
      return "Before Dinner";

    case "dinner":
      return "Dinner";

    case "postDinner":
      return "Post Dinner";

    case "lateNight":
      return "Late Night";

    default:
      break;
  }
};

export const timerChart = (key) => {
  switch (key) {
    case "earlyMorning":
      return "6:30";

    case "breakfast":
      return "7:30";

    case "midMorning":
      return "9:30";

    case "brunch":
      return "10:30";

    case "midMeal":
      return "11:30";

    case "lunch":
      return "01:30";

    case "postLunch":
      return "03:30";

    case "evening":
      return "05:30";

    case "beforeDinner":
      return "07:30";

    case "dinner":
      return "09:30";

    case "postDinner":
      return "11:30";

    case "lateNight":
      return "00:30";

    default:
      break;
  }
};

export const chartHandler = (table) => {
  let chartObj = {
    earlyMorning: null,
    breakfast: null,
    midMorning: null,
    brunch: null,
    midMeal: null,
    lunch: null,
    postLunch: null,
    evening: null,
    beforeDinner: null,
    dinner: null,
    postDinner: null,
    lateNight: null,
  };

  table.forEach((ele) => {
    if (Array.isArray(ele.list) && chartObj.hasOwnProperty(ele.timing)) {
      chartObj[ele.timing] = ele.list;
    }
  });

  Object.keys(chartObj).forEach((key) => {
    if (!Array.isArray(chartObj[key]) || chartObj[key].length === 0) {
      delete chartObj[key];
    }
  });

  return chartObj;
};

export const dietRecallHandler = (table) => {
  let chartObj = {
    earlyMorning: null,
    breakfast: null,
    midMorning: null,
    brunch: null,
    midMeal: null,
    lunch: null,
    postLunch: null,
    evening: null,
    beforeDinner: null,
    dinner: null,
    postDinner: null,
    lateNight: null,
  };

  Object.keys(chartObj).forEach((key) => {
    if (table[key]) {
      chartObj[key] = table[key];
    } else {
      delete chartObj[key];
    }
    return key;
  });

  return chartObj;
};

export function onTimeChange(val) {
  if (!val) {
    val = "15:00";
  }
  let timeSplit = val.split(":");
  let hours, minutes, meridian;

  hours = timeSplit[0];
  minutes = timeSplit[1];

  if (hours > 12) {
    meridian = "PM";
    hours -= 12;
  } else if (hours < 12) {
    meridian = "AM";
    if (hours === 0) {
      hours = 12;
    }
  } else {
    meridian = "PM";
  }

  return hours + ":" + minutes + " " + meridian;
}

export function getDateDurationInDays(data) {
  const dietChart = data;
  if (!dietChart || !dietChart.from || !dietChart.to) return null;

  const fromDate = new Date(dietChart.from);
  const toDate = new Date(dietChart.to);

  const diffInMs = toDate - fromDate;
  const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

  return diffInDays + 1;
}

export const renderDietPdfNotes = (htmlContent) => {
  const isPlainText = !/<[a-z][\s\S]*>/i.test(htmlContent);

  if (isPlainText) {
    return htmlContent
      .split("\n")
      .filter((line) => line.trim() !== "")
      .map((line, index) => {
        const match = line.trim().match(/^(\d+)\.\s*(.*)|^(\d+)\.(.*)$/);
        const number = match ? match[1] || match[3] : null;
        const text = match ? match[2] || match[4] : line.trim();
        return (
          <Text key={index} style={terms_conditions_styles.p}>
            {number ? `${number}. ${text}` : text}
          </Text>
        );
      });
  } else {
    return (
      <Html style={[dietNotes.para, { marginBottom: 0 }]}>{htmlContent}</Html>
    );
  }
};

export function calculateWeeklyNutritionTotals(dietData) {
  const totals = {
    totalCalories: 0,
    totalProtein: 0,
    totalFat: 0,
    totalSugar: 0,
    totalCarbs: 0,
  };

  dietData.forEach((day) => {
    day.table.forEach((timingBlock) => {
      if (Array.isArray(timingBlock.list)) {
        timingBlock.list.forEach((item) => {
          // Add calories
          if (item.calories) {
            totals.totalCalories += item.calories;
          }

          // Add nutrition values
          if (Array.isArray(item.nutritions)) {
            item.nutritions.forEach((nut) => {
              const grams = parseFloat(nut.grams) || 0;
              switch (nut?.type?.toLowerCase()) {
                case "protein":
                  totals.totalProtein += grams;
                  break;
                case "fat":
                case "fats":
                  totals.totalFat += grams;
                  break;
                case "sugar":
                  totals.totalSugar += grams;
                  break;
                case "carbohydrate":
                case "carbohydrates":
                  totals.totalCarbs += grams;
                  break;
              }
            });
          }
        });
      }
    });
  });

  return totals;
}

export const launchRazorpay = async ({
  formdata,
  paymentData,
  referenceDetails,
  amount,
  referAmount,
  onPaymentSuccess,
  onPaymentFailure,
}) => {
  const res = await loadScript("https://checkout.razorpay.com/v1/checkout.js");

  if (!res) {
    toast.error("Razorpay SDK failed to load, retry");
    return;
  }

  let orderResponse;

  try {
    const { data } = await createRazorpayOrder({
      amount: amount,
    });
    orderResponse = data;
  } catch (error) {
    toast.error("Failed to create Razorpay order.");
    console.error("Order Creation Error:", error);
    return;
  }

  const options = {
    key: process.env.REACT_APP_RAZORPAY_KEY,
    currency: "INR",
    name: "Fitify",
    description: "Subscription Renewal",
    image: Logomain,
    currency: "INR",
    order_id: orderResponse.orderId,
    prefill: {
      name: formdata.name,
      email: formdata.email,
      contact: formdata.phoneNumber,
    },
    handler: function (response) {
      const finalResponse = {
        ...response,
        subscriptionAmount: parseFloat(paymentData.paymentAmount),
        amount: amount / 100,
        referAmount: parseFloat(referAmount),
      };

      if (onPaymentSuccess && typeof onPaymentSuccess === "function") {
        onPaymentSuccess(finalResponse, paymentData, referenceDetails);
      }
    },
    modal: {
      ondismiss: function () {
        if (onPaymentFailure && typeof onPaymentFailure === "function") {
          onPaymentFailure("User closed the payment popup");
        }
      },
    },
  };

  const paymentObj = new window.Razorpay(options);

  paymentObj.on("payment.failed", function (response) {
    if (onPaymentFailure && typeof onPaymentFailure === "function") {
      onPaymentFailure(response.error);
    }
  });

  paymentObj.open();
};

export function deduplicateDietCharts(charts) {
  const map = new Map();

  charts.forEach((chart) => {
    const key =
      chart.layoutVariant === "perDayRange" && chart.from
        ? `${chart.dietChartId}_${chart.from}`
        : chart.dietChartId;
    map.set(key, chart);
  });

  return Array.from(map.values());
}

export const fetchUSDExchangeRate = async () => {
  try {
    const res = await fetch("https://api.exchangerate-api.com/v4/latest/INR");
    const data = await res.json();
    return data.rates.USD;
  } catch (error) {
    console.error("Failed to fetch exchange rate:", error);
  }
};

export const calculateProductBill = (bill) => {
  const {
    amountPaid = 0,
    discount = 0,
    sellingPriceWOT = 0,
    quantity = 1,
    gst = 0,
  } = bill;

  const parsedAmountPaid = parseFloat(amountPaid) || 0;
  const parsedDiscount = parseFloat(discount) || 0;
  const parsedSellingPrice = parseFloat(sellingPriceWOT) || 0;
  const parsedQuantity = parseFloat(quantity) || 1;
  const parsedGst = parseFloat(gst) || 0;

  const totalAmountBeforeTax = parsedSellingPrice * parsedQuantity;
  const gstAmount = ((parsedSellingPrice * parsedGst) / 100) * parsedQuantity;
  const totalAmount = totalAmountBeforeTax + gstAmount;
  const balance = totalAmount - parsedDiscount - parsedAmountPaid;

  const format = (num) => parseFloat(num.toFixed(2));

  return {
    ...bill,
    totalAmountBeforeTax: format(totalAmountBeforeTax),
    gstAmount: format(gstAmount),
    totalAmount: format(totalAmount),
    discount: format(parsedDiscount),
    amountPaid: format(parsedAmountPaid),
    balance: format(balance),
    totalTaxRate: parsedGst,
  };
};
